/*Recurso: Proposal - Servicio de lectura del API: Maneja las notificaciones presentadas en el encabezado del sistema (campana)
  Tareas:
    GetSummarybyUser   
    GetDetailbyUser   
    InsertbyUser 
    UpdatebyUser
    DeletebyUser
    SendbyUser
*/

import axios from "axios";
import {IBodyUpdatebyUser} from "./proposals.modelo";

//recurso: Proposals
const API_URL = process.env.REACT_APP_API_URL + 'Proposals/';

  //se genera una función por cada tarea del recurso api

    //tarea: GetSummarybyUser
    const cargaGetSummarybyUser = async (token:any) => {
       //console.log ('***API: ' + API_URL + 'GetSummarybyUser/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetSummarybyUser/es', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: GetDetailbyUser
    const cargaGetDetailbyUser = async (token:any, id:any) => {
      //console.log ('***API: ' + API_URL + 'GetDetailbyUser/es/'+id,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetDetailbyUser/es/'+id, 'method: post',
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };    

   //tarea: InsertbyUser 
    const cargaInsertbyUser = async (token:any, datosPropuesta:any) => {
      //console.log ('***API: ' + API_URL + 'InsertbyUser/es', datosPropuesta,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'InsertbyUser/es', datosPropuesta, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: UpdatebyUser 
    const cargaUpdatebyUser = async (token:any, datosPropuesta:any) => {
      //console.log ('***API: ' + API_URL + 'UpdatebyUser/es', datosPropuesta,  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'UpdatebyUser/es', datosPropuesta, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

     //tarea: DeletebyUser  
     const cargaDeletebyUser = async (token:any, id:any) => {
      //console.log ('***API: ' + API_URL + 'DeletebyUser/'+id, {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'DeletebyUser/'+id,  'method: post',
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: SendbyUser 
    const cargaSendbyUser =   (token:any, datosPropuesta:any) => {
      console.log ('***API: ' + API_URL + 'SendbyUser/es', datosPropuesta,  {headers: { 'content-type': 'text/json' }} )
      return  axios.post(API_URL + 'SendbyUser/es', datosPropuesta, 
          {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

const proposalsService = {
    cargaGetSummarybyUser: cargaGetSummarybyUser,
    cargaGetDetailbyUser: cargaGetDetailbyUser,
    cargaInsertbyUser: cargaInsertbyUser,
    cargaUpdatebyUser: cargaUpdatebyUser,
    cargaDeletebyUser: cargaDeletebyUser,
    cargaSendbyUser: cargaSendbyUser,
};

export default proposalsService;
